import Editor from './editor'
import MessageBox from './messageBox'
import Modal from './modal'
import Notify from './notify'
import Upload from './upload'
import Loader from './loader'
import Panel from './panel'

export * from './editor'
export * from './messageBox'
export * from './modal'
export * from './notify'
export * from './upload'
export * from './loader'
export * from './panel'

export default {
  options: {

    // 富文本编辑器，false则不安装
    editor: {},

    // 图片预览，false则不安装
    messageBox: {},

    // Modal，false则不安装
    modal: {},

    // 扩展Vue实例的提示方法，false则不安装
    notify: {},

    // 文件/图片上传，false则不安装
    // 提供的配置将会替换组件props的默认值
    upload: {},

    // 扩展Vue实例加载中方法，false则不安装
    loader: {}

  },
  atEditor: Editor,
  atMessageBox: MessageBox,
  atModal: Modal,
  atNotify: Notify,
  atUpload: Upload,
  atLoader: Loader,
  AtPanel: Panel,
  install(Vue, options = {}) {
    let opts = Object.assign({}, this.options, options)

    if (opts.editor !== false) {
      Vue.use(Editor, opts.editor)
    }
    if (opts.messageBox !== false) {
      Vue.use(MessageBox, opts.messageBox)
    }
    if (opts.modal !== false) {
      Vue.use(Modal, opts.modal)
    }
    if (opts.notify !== false) {
      Vue.use(Notify, opts.notify)
    }
    if (opts.upload !== false) {
      Vue.use(Upload, opts.upload)
    }
    if (opts.loader !== false) {
      Vue.use(Loader, opts.loader)
    }
    if (opts.panel !== false) {
      Vue.use(Panel, opts.panel)
    }
  }
}



// WEBPACK FOOTER //
// ./src/packages/components/index.js